import React from "react";
import Captcha from "components/Form/Field/Captcha";
import Hidden from "components/Form/Field/Hidden";
import Input from "components/Form/Field/Input";
import Textarea from "components/Form/Field/Textarea";
import Checkbox from "components/Form/Field/Checkbox";
import Radios from "components/Form/Field/Radios";
import Actions from "components/Form/Field/Actions";
import Checkboxes from "components/Form/Field/Checkboxes";
import Select from "components/Form/Field/Select";

export default function Field({
  captchaRef,
  field,
  control,
  register,
  errors: fieldsErrors,
}) {
  const fieldProps = {
    id: field["#webform_id"],
    name: field["#webform_key"],
    label: field["#title"],
    type: field["#type"],
    options: field["#options"] || [],
    placeholder: field["#placeholder"] || "",
    suffix: field["#field_suffix"] || null,
    labelDisplay: field["#title_display"] || null,
    description: field["#description"] || null,
    required: field["#required"] || false,
  };
  const errors = fieldsErrors?.[fieldProps.name];

  switch (fieldProps.type) {
    case "hidden":
      if (fieldProps.name === "captcha") {
        return <Captcha ref={captchaRef} />;
      }

      return <Hidden {...fieldProps} register={register} />;
    case "textfield":
    case "number":
    case "email":
    case "tel":
      return <Input {...fieldProps} register={register} errors={errors} />;
    case "textarea":
      return <Textarea {...fieldProps} register={register} errors={errors} />;
    case "radios":
      return <Radios {...fieldProps} control={control} errors={errors} />;
    case "checkbox":
      return <Checkbox {...fieldProps} control={control} errors={errors} />;
    case "checkboxes":
      return <Checkboxes {...fieldProps} control={control} errors={errors} />;
    case "select":
      return <Select {...fieldProps} control={control} errors={errors} />;
    case "webform_actions":
      return <Actions label={field?.["#submit__label"]} />;
    default:
      // eslint-disable-next-line no-console
      console.warn(`The "${field["#type"]}" field type is not handled.`);
      return null;
  }
}
